const path = require('path')
const MI_LOCAL = 'milocal'
const CONNECT = 'connect'
const PRODUCT_SCAN = 'tool-product-scan'

// install global https://www.npmjs.com/package/add-dependencies to add dependencies to nodemodules without install them
const dependencies = {
  [MI_LOCAL]: [
    '@awesome-cordova-plugins/core',
    '@awesome-cordova-plugins/in-app-browser',
    '@capacitor-community/fcm',
    '@capacitor/splash-screen',
    'react-customizable-progressbar',
    '@capacitor/geolocation'
  ],
  [CONNECT]: [],
  [PRODUCT_SCAN]: ['@capacitor-community/barcode-scanner', '@capacitor/camera']
}

module.exports = {
  boilerplate: {
    description: 'application template',
    prompts: [
      {
        type: 'list',
        name: 'lenguage',
        message: 'Please select your lenguage',
        choices: [
          { name: 'Español', value: 'es', checked: true },
          { name: 'English', value: 'en' },
          { name: 'Portugues', value: 'br' }
        ]
      },
      {
        type: 'list',
        name: 'selection',
        message: 'What can I do for you? 😊',
        choices: [
          { name: 'Mi Local Template', value: MI_LOCAL, checked: true },
          { name: 'Connect Template', value: CONNECT }
        ]
      }
    ],
    actions: (answers) => [
      {
        type: 'addMany',
        destination: '../src/',
        base: path.resolve(__dirname, './src/tools/templates/{{selection}}'),
        templateFiles: path.resolve(__dirname, './src/tools/templates/{{selection}}/**'),
        force: true
      },
      'Installing new dependencies',
      {
        type: 'npmInstallPackages',
        install: dependencies[answers.selection]
      }
    ]
  },
  module: {
    description: 'application modules',
    prompts: [
      {
        type: 'list',
        name: 'selection',
        message: 'What type of module you need? 😊',
        choices: [{ name: 'Product Scan', value: PRODUCT_SCAN, checked: true }]
      }
    ],
    actions: (answers) => [
      {
        type: 'addMany',
        destination: '../src/pages/tools/{{selection}}',
        base: path.resolve(__dirname, './src/modules/{{selection}}'),
        templateFiles: path.resolve(__dirname, './src/modules/{{selection}}/**'),
        force: true
      },
      'Installing new dependencies',
      {
        type: 'npmInstallPackages',
        install: dependencies[answers.selection]
      }
    ]
  }
}
